import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { containsIntangible } from '@/modules/perseo-billing/components/accordion';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';

interface InvoiceOrGiftCardModalProps {
  isOpen: boolean;
  setIsDisabledInvoiceModalOpen: (isOpen: boolean) => void;
}
export const InvoiceOrGiftCardModal = ({
  isOpen,
  setIsDisabledInvoiceModalOpen
}: InvoiceOrGiftCardModalProps) => {
  const { data } = useAppSelector((state) => state.cart);
  const hasIntangible = containsIntangible(data!);
  const { continueWithInvoiceGtm } = useGtmBillingProduct();

  const onClose = () => {
    setTimeout(() => {
      continueWithInvoiceGtm('Gift Card');
      setIsDisabledInvoiceModalOpen(false);
    }, 0);
  };

  return (
    <Modal onClose={onClose} size="md" isOpen={isOpen}>
      <ModalHeader
        icon={{ name: 'warning-circle', fill: 'warning-500' }}
        onClose={onClose}
        title="¿Quieres pagar con factura?"
      />
      <ModalBody className="co-flex co-flex-col">
        <Text className="co-text-left co-mt-2">
          {hasIntangible
            ? 'No puedes comprar Gift Cards ni servicios usando factura. Continúa con boleta o elimina el producto del carro.'
            : 'El pago con Gift Card no está disponible con factura. Por favor, elimina tu Gift Card para comprar como empresa.'}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button block onClick={onClose}>
          Entendido
        </Button>
      </ModalFooter>
    </Modal>
  );
};
